// Splide init
function mmInitSplide() {
    const splideElem = document.querySelector(".mm-splide-crossell");

    if (splideElem) {
        new Splide(splideElem, {
            type: "splide",
            arrows: true,
            pagination: false,
            rewind: true,
            gap: "8px",
            perPage: 1,
            padding: {
                left: "0px",
                right: "80px"
            },
          breakpoints: {
            768: {
              arrows: false
            },
            360: {
              padding: {
                right: "40px"
              }
            },
            320: {
              padding: {
                right: "0px"
              }
            }
          }
        }).mount();
    }
}

document.addEventListener(
    "DOMContentLoaded",
    () => {
        mmInitSplide();
        //mmOpenCart();
    },
    { once: true }
);

function debounce(func, duration) {
    let timeout;
    return function (...args) {
        const effect = () => {
            timeout = null;
            return func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(effect, duration);
    };
}

function mmCartSectionElement() {
    return document.getElementById("shopify-section-mm-cart");
}

function mmCartProductsContainerElement() {
    return mmCartSectionElement().querySelector(".mm-dc-products-container");
}

function mmCartItem(productVariantId) {
    return mmCartProductsContainerElement().querySelector(`[data-cart-item-id="${productVariantId}"]`);
}

function mmCartItemQuantityEl(productVariantId) {
    const itemEl = mmCartItem(productVariantId);

    return itemEl.querySelector("[data-item-quantity]");
}

function mmGetCartItemQuantity(productVariantId) {
    const quantityEl = mmCartItemQuantityEl(productVariantId);

    return Number.parseInt(quantityEl.dataset.itemQuantity);
}

function mmSetCartItemQuantity(productVariantId, newQuantity) {
    // Display qtty in front
    if (newQuantity >= 0) {
        const quantityEl = mmCartItemQuantityEl(productVariantId);

        quantityEl.dataset.itemQuantity = newQuantity;
        quantityEl.innerText = newQuantity;
    }
}

function mmCartHTMLFromData(data) {
    const el = document.createElement("DIV");
    el.innerHTML = data.sections["mm-cart"];

    return el;
}

function extractItemsFromCartHTML(data) {
    const el = mmCartHTMLFromData(data);
    return el.querySelector(".mm-dc-products-container");
}

function insertCartProductsFromResponse(data) {
    const itemsContainer = extractItemsFromCartHTML(data);
    mmCartProductsContainerElement().innerHTML = itemsContainer.innerHTML;

    return data;
}

function extractTotalPriceFromCartHTML(data) {
    const cartEl = mmCartHTMLFromData(data); // ¡ fait atención gringo !
    return cartEl.querySelector("[data-cart-total-price]");
}

function insertInsertTotalPriceFromResponse(data) {
    const newTotalPriceEl = extractTotalPriceFromCartHTML(data);
    const currentTotalPriceEl = mmCartSectionElement().querySelector("[data-cart-total-price]");
    currentTotalPriceEl.innerHTML = newTotalPriceEl.innerHTML;

    return data;
}

function mmAPIRequest(method, path, body) {
    document.querySelector(".mm-dc-products")?.classList?.add("mm-inactive");
    return fetch(window.Shopify.routes.root + path, {
        method: method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
    })
    .then((response) => response.json())
    .then((data) => {
        // mmLog(data);
        updateCartCount();
        mmInitSplide();
        document.querySelector(".mm-dc-products")?.classList?.remove("mm-inactive");
        if (data.status && data.status > 400) {
            throw data;
        } else {
            return data;
        }
    });
}

// récupérer le panier
function mmGetCart() {
    return mmAPIRequest("GET", "cart.js");
}

// Ouvrir le panier
function mmOpenCart() {
    mmGetCart();
    document.querySelector(".mm-drawer-cart-wrapper").classList.add("mm-dc-is-open");
    document.querySelector("html").classList.add("stop-scrolling");
}

// Ouvrir et refresh le panier
function mmOpenAndRefreshCart() {
    function handleResponse() {
        const newCartEl = document.createElement("DIV");
        newCartEl.innerHTML = this.responseText;
        const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart-wrapper");
        innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart-wrapper").innerHTML;
        //console.log('newCartEl', newCartEl)
        mmInitSplide();
        updateCartCount();
        document.querySelector(".mm-drawer-cart-wrapper").classList.add("mm-dc-is-open");
        document.querySelector("html").classList.add("stop-scrolling");
    }
    const request = new XMLHttpRequest();
    request.addEventListener("load", handleResponse);
    request.open("GET", `${getLangPath()}?section_id=mm-cart`, true);
    request.send();
}

function getLangPath() {
    const urlObj = new URL(window.location.href);
    const pathParts = urlObj.pathname.split("/").filter(part => part !== ""); // Supprime les vides dus aux "/"

    if (pathParts.length === 0) {
        return "/"; // Cas de la page d'accueil
    }

    return "/" + pathParts[0]; // Retourne seulement le premier segment après le domaine
}

// Ouvrir et refresh le panier
function mmRefreshCart() {
    function handleResponse() {
        const newCartEl = document.createElement("DIV");
        newCartEl.innerHTML = this.responseText;
        const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart-wrapper");
        innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart-wrapper").innerHTML;
        //console.log('newCartEl', newCartEl)
        mmInitSplide();
        updateCartCount();
    }
    const request = new XMLHttpRequest();
    request.addEventListener("load", handleResponse);
    request.open("GET", "/?section_id=mm-cart", true);
    request.send();
}

// Fermer le panier
function mmCloseCart() {
    document.querySelector(".mm-drawer-cart-wrapper").classList.remove("mm-dc-is-open");
    document.querySelector("html").classList.remove("stop-scrolling");
}

// Re-render cart inner HTML from response
function refreshCartFromData(data) {
    const newCartEl = document.createElement("DIV");
    newCartEl.innerHTML = data.sections["mm-cart"];
    const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart-wrapper");
    innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart-wrapper").innerHTML;
    mmInitSplide();
    updateCartCount();
    return data;
}

// Fonction pour soumettre le formulaire de produit
function mmSubmitProductForm(productId, { quantity = 1, openCart = true }) {
  let items = [];
  
  // Vérifiez si le sélecteur de quantités est présent sur la page
  const mainProductQuantityElement = document.getElementById('mmMainProductQuantity');
  const mainProductQuantity = mainProductQuantityElement ? parseInt(mainProductQuantityElement.value) : 1;

  // Ajoutez le produit principal avec la bonne quantité
  items.push({ id: productId, quantity: mainProductQuantity });

  // Sélectionnez les produits cross-sell et ajoutez-les avec une quantité de 1
  const crossSellProducts = document.querySelectorAll('.mm-product-cross-sell-item-input:checked');
  if (crossSellProducts.length > 0) {
    crossSellProducts.forEach(function(crossSellProduct) {
      items.push({ id: crossSellProduct.value, quantity: 1 });
    });
  }

  mmAddProductsToCart(items, { openCart: true });
}

// Ajouter plusieurs produits au panier
function mmAddProductsToCart(items, { openCart = true }) {
    mmAPIRequest("POST", "cart/add.js", {
        items: items,
        sections: "mm-cart",
    })
    .then(refreshCartFromData)
    .then((data) => {
        if (openCart) {
            setTimeout(mmOpenCart);
        }
    })
    .catch((error) => {
        alert(`L'ajout au panier n'a pas fonctionné, il n'y a probablement plus de stocks sur ce produit`);
        mmOpenCart();
        console.log(error);
    });
}

// Ajouter un item au panier
function mmAddProductToCart(productId, { quantity = 1, openCart = true }) {
  
    if (document.getElementById('mmMainProductQuantity')) {
      let quantity = document.getElementById('mmMainProductQuantity').value;
    }
  
    mmAPIRequest("POST", "cart/add.js", {
        items: [{ quantity: quantity, id: productId }],
        sections: "mm-cart",
    })
    .then(refreshCartFromData)
        .then((data) => {
            if (openCart) {
                setTimeout(mmOpenCart);
            }
        })
        .catch((error) => {
            alert(`L'ajout au panier n'a pas fonctionné, il n'y a probablement plus de stocks sur ce produit`);
            mmOpenCart();
            console.log(error);
        });
}

function mmIncreaseProductQuantity(productVariantId) {
    const quantity = mmGetCartItemQuantity(productVariantId);
    const newQuantity = quantity + 1;
    mmSetCartItemQuantity(productVariantId, newQuantity);

    mmDebouncedPushNewQuantity(productVariantId);
}

function mmDecreaseProductQuantity(productVariantId) {
    const quantity = mmGetCartItemQuantity(productVariantId);
    const newQuantity = quantity - 1;
    mmSetCartItemQuantity(productVariantId, newQuantity);

    mmDebouncedPushNewQuantity(productVariantId);
}

function mmDestroyProductFromCart(productVariantId) {
    const newQuantity = 0;
    mmSetCartItemQuantity(productVariantId, newQuantity);

    mmDebouncedPushNewQuantity(productVariantId);
}

function mmPushNewQuantity(productVariantId) {
    const quantity = mmGetCartItemQuantity(productVariantId);

    mmAPIRequest("POST", "cart/change.js", {
        id: productVariantId.toString(),
        quantity: quantity,
        sections: "mm-cart",
    })
    .then(refreshCartFromData);
}

function mmChangeFreeProductInCart(productVariantIdToAdd, productVariantIdToRemove, clickedElem) {
    // Debounce sur le CTA
    clickedElem.innerText = "AJOUTÉ !";
    clickedElem.classList.add("mm-disabled");

    mmAPIRequest("POST", "cart/add.js", {
        items: [{ quantity: 1, id: productVariantIdToAdd }],
        sections: "mm-cart",
    }).then(mmDestroyProductFromCart(productVariantIdToRemove));
}

const mmDebouncedPushNewQuantity = debounce(function (productVariantId) {
    mmPushNewQuantity(productVariantId);
}, 300);


function updateCartCount() {
  const value = document.querySelector('.mm-dc-header').dataset.cartCount;
  const bubble = document.querySelector(".mm-navbar__icon-container span");

  console.log('value', value)
  bubble.innerText = value;
}

// Soumission du product form
document.addEventListener('DOMContentLoaded', function() {
  const productForm = document.getElementById('product-form');

  if(productForm) {
    productForm.addEventListener('submit', function(event) {
      event.preventDefault(); // Empêche le rechargement de la page
  
      const formData = new FormData(productForm);
  
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        // Produit ajouté avec succès
        mmOpenAndRefreshCart();
      })
      .catch(error => {
        console.error('Erreur lors de l\'ajout au panier:', error);
      });
    });
  }

  function updateCart() {
    fetch('/cart', {
      method: 'GET',
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.text();
    })
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const cartDrawerContent = doc.querySelector('.mm-drawer-cart').innerHTML;
      document.querySelector('.mm-drawer-cart').innerHTML = cartDrawerContent;
      mmOpenCart(); // Ouverture du tiroir du panier
    })
    .catch(error => {
      console.error('Erreur lors de la mise à jour du panier:', error);
    });
  }
});

window.addEventListener('pageshow', function (event) {
    if (event.persisted) { // Détecte si la page vient du cache
        mmRefreshCart(); // Appeler une fonction pour synchroniser l'état du panier
    }
});

